<template>
  <div class="activity-cont">
    <van-pull-refresh v-model="loading" @refresh="onRefresh" v-if="activityStart">
      <navBar :title="'818嗨课节 火热进行中'" @back="handleNavBack"/>
      <!-- 顶部计时分享 -->
      <countDown :time="second"/>
      <div class="activity-top-bg">
        <!-- 分享个人中心 -->
        <div class="share-btn">
          <img src="https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659697226940.png" alt="" @click="$router.push('/personal')">
          <span class="line"></span>
          <img src="https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659697237441.png" alt="" @click="handleShare">
        </div>
      </div>
      <!-- 限时秒杀 -->
      <div class="time-up-bg">
        <div class="activity-seckill-tab">
          <ul class="seckill-tab-cont">
            <li
              v-for="(item, index) in timeList"
              :key="index"
              class="seckill-tab-item"
              @click="activeIndex = item.index">
              <!-- 即将开始 -->
              <img :src="activeIndex == item.index ? item.img4 : item.img1" alt="" v-if="!item.currentSale">
              <!-- 抢购中 -->
              <img :src="currentSale == item.index && activeIndex == item.index ? item.img2 : item.img3" alt="" v-if="item.currentSale">
            </li>
          </ul>
        </div>
        <commodityLr
          :goodsData="seckillList[activeIndex == 0 ? 0 : activeIndex -1]"
          :isGroupGood="false"
          :index="activeIndex == 0 ? 1 : activeIndex"
          @detail="openGoodsDetail"
          v-if="seckillList.length"
        />
      </div>
      <!-- 好课拼团 -->
      <div class="class-groud-bg">
        <commodityLr
          v-for="(item,index) in groupList"
          :key="index"
          :goodsData="item"
          :index="index+1"
          @detail="openGoodsDetail"
        />
      </div>
      <!-- 精品课程 -->
      <div class="excellent-course-bg">
        <div v-for="(item,index) in goodsList" :key="index">
          <activityTitle :index="index"/>
          <commodityTb
            :goodsList="item.list"
            v-if="item"
            @detail="openGoodsDetail"/>
        </div>
      </div>
      <!-- 免费专区 -->
      <div class="free-bg">
        <commodityTb
          :goodsList="freeList"
          :isFree="true"
          @detail="openGoodsDetail"
          v-if="freeList.length"
        />
      </div>
      <!-- 百企联盟 -->
      <div class="company-ally">
        <scrollLogo />
      </div>
      <!-- 活动说明 -->
      <div class="activity-description">
        <p>1.秒杀产品，每个时段有效抢购时间为1小时。</p>
        <p>2.购买者需输入有效电话。</p>
        <p>3.开团有效时间为6小时，有效时间内成功邀请用户拼团（完成支付）即拼团成功。</p>
        <p>4.本活动最终解释权归伟东集团有限责任公司所有。</p>
      </div>
      <!-- 客服 -->
      <div class="customer-service">
        <img src="https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660621554849.jpg" alt="">
      </div>
      <!-- 分享遮罩 -->
      <shareGuide ref="share"/>
    </van-pull-refresh>
    <!-- 活动未开始或已结束 -->
    <div
      v-else
      class="un-activity"
      @click="handleNavBack"
      :style="{
        'background': `url(${unactivity}) no-repeat center center`,
        'background-size': '100% 100%'
      }">
    </div>
  </div>
</template>
<script>
import countDown from '../components/countDown.vue';
import commodityLr from '../components/commodity_lr.vue';
import commodityTb from '../components/commodity_tb.vue';
import activityTitle from '../components/activity_title.vue';
import shareGuide from '../components/share_guide.vue';
import scrollLogo from '../components/scroll_logo.vue';
import navBar from '../components/navBar.vue';
export default {
  name: 'activity',
  components: {
    countDown,
    commodityLr,
    commodityTb,
    activityTitle,
    shareGuide,
    scrollLogo,
    navBar
  },
  data() {
    let branchId = this.$route.query.branchId || localStorage.getItem('branchId');
    return {
      branchId,
      viewStart: 0,// 页面开始浏览时间
      currentSale: 0, // 当前正在秒杀时间段
      activeIndex: 0, // 当前tab选中
      downloadTipsShow: true,// 是否在微信钉钉环境
      loading: false, // 下拉刷新
      activityStart: true, // 活动是否开始
      second: 0,// 倒计时秒数
      // endTime: 0,// 活动结束日期
      seckillList: [], // 秒杀商品列表
      freeList: [], // 获取免费商品
      excellentCourse: [],// 精品课程
      groupList: [], // 拼团商品
      unactivity: 'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660543064135.png',// 活动未开始、结束占位图
      goodsList: [],// 精品推荐
      timeList: [{
        index: 1,
        currentSale: false,
        img1: 'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659762042072.png', // 即将开始灰
        img2: 'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659925182097.png', // 正在抢购红
        img3: 'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659761914162.png', // 抢购灰
        img4: 'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659761800832.png' // 即将开始红
      },{
        index: 2,
        currentSale: false,
        img1: 'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659762392026.png', // 即将开始灰
        img2: 'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659925221958.png', // 正在抢购红
        img3: 'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659762355689.png', // 抢购灰
        img4: 'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659762278640.png' // 即将开始红
      },{
        index: 3,
        currentSale: false,
        img1: 'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659762519443.png', // 即将开始灰
        img2: 'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659925239467.png', // 正在抢购红
        img3: 'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659762543118.png', // 抢购灰
        img4: 'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659762569707.png' // 即将开始红
      },
      {
        index: 4,
        currentSale: false,
        img1: 'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659762593633.png', // 即将开始灰
        img2: 'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659925260356.png', // 正在抢购红
        img3: 'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659762618891.png', // 抢购灰
        img4: 'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659762648180.png' // 即将开始红
      },{
        index: 5,
        currentSale: false,
        img1: 'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659762670630.png', // 即将开始灰
        img2: 'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659925284352.png', // 正在抢购红
        img3: 'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659762697772.png', // 抢购灰
        img4: 'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1659762714295.png' // 即将开始红
      }]
    }
  },
  created() {
    document.title = '818嗨课节'
    console.log(document.title,'document.title')
    // 隐藏页头
    let navDom = document.getElementsByClassName('navCs')[0];
    if(navDom) navDom.style.display = 'none';
    // 获取活动是否开始
    this.findActivityTime();
    // 埋点活动页曝光
    this.$sensors.track('mkt_page_show',{
      mkt_page_title: '818嗨课节',
    })
  },
  mounted() {
    // 隐藏页头
    let navDom = document.getElementsByClassName('navCs')[0];
    if(navDom) navDom.style.display = 'none';
  },
  beforeDestroy() {
    let endTime = new Date();
    // 埋点活动页浏览
    this.$sensors.track('mkt_page_show',{
      mkt_page_title: '818嗨课节',
      mkt_view_duration: (endTime - this.viewStart) / 1000
    })
    document.title = localStorage.getItem('pageTitle');
  },
  methods: {
    // 获取活动开始截止时间
    findActivityTime() {
      this.$api.grouppurchase.findActivityTime().then((res)=> {
        if (res.success) {
          let date = new Date();
          let start = new Date(res.data.startTime);
          let end = new Date(res.data.endTime);
          let nowDay = date.getDate();
          this.viewStart = date; // 页面开始浏览时间
          if (nowDay >= start.getDate() && nowDay <= end.getDate() && start.getMonth() == date.getMonth() && date.getFullYear() == start.getFullYear()) {
            this.activityStart = true;// 活动开始
            this.second = Math.abs(end - date); // 倒计时开始
            this.gethouerTime();
            // 拼团商品
            this.findGroupGoodsList();
            // 获取推荐商品
            this.getGoodsCategory();
            // 获取免费列表
            // this.channelGoodsList(1,6);
          } else {
            this.activityStart = false;
            if (nowDay < start.getDate() && start.getMonth() == date.getMonth() && date.getFullYear() == start.getFullYear()) { // 未开始
              this.unactivity = 'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660543025093.png'
            } else if (nowDay > end.getDate()) { // 活动结束
              this.unactivity = 'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660543064135.png'
            }
          }
        }
      })
      setTimeout(()=> {
        this.loading = false;
      },1000)
      console.log(this.activityStart,'活动是否开始')
    },
    // 获取秒杀
    gethouerTime() {
      const date = new Date();
      let hours = date.getHours();
      let index = 0;
      if (hours >= 10 && hours < 11) {
        this.currentSale = 1;
        this.activeIndex = 1;
        index = 1
      } else if (hours >= 12 && hours < 13) {
        this.currentSale = 2;
        this.activeIndex = 2;
        index = 2;
      } else if (hours >= 14 && hours < 15) {
        this.currentSale = 3;
        this.activeIndex = 3;
        index = 3
      } else if (hours >= 16 && hours < 17) {
        this.currentSale = 4;
        this.activeIndex = 4;
        index = 4
      } else if (hours >= 20 && hours < 21) {
        this.currentSale = 5;
        this.activeIndex = 5;
        index = 5
      }
      this.setTabSelect(index);
      this.findByCondition();
    },
    // 设置tab每一项选中状态
    setTabSelect(index) {
      this.timeList.map(item => {
        if (item.index == index) {
          item.currentSale = true;
        } else {
          item.currentSale = false;
        }
      })
    },
    // 获取秒杀商品列表
    async findByCondition() {
      let data = {
        branchId: this.branchId
      }
      let res = await this.$api.grouppurchase.findByCondition(data);
      if (res.success) {
        this.seckillList = res.data;
      }
    },
    // 拼团商品
    async findGroupGoodsList() {
      let params = {
        branchId: this.branchId,
        saasId: localStorage.getItem('saasId'),
        pageNum: 1,
        pageSize: 4
      }
      let res = await this.$api.grouppurchase.findGroupGoodsList(params);
      if (res.success) {
        this.groupList = res.data.list;
      }
    },
    // 获取精品课程分类
    async getGoodsCategory() {
      let res = await this.$api.grouppurchase.getGoodsCategory();
      if (res.success) {
        for (let i = 0 ; i < res.data.length -1; i++) {
          this.getRecommendGood(res.data[i],i)
        }
        // 获取免费列表
        if (res.data) {
          this.channelGoodsList(res.data[6]);
        }
      }
    },
    // 获取精品课程推荐列表
    async getRecommendGood(ids,index) {
      let data = {
        branchId: this.branchId,
        ids: ids
      }
      let res = await this.$api.grouppurchase.getRecommendGood(data);
      if (res.success) {
        let data = {
          list: res.data
        }
        this.$set(this.goodsList, index, data)
      }
      console.log(res,index,'getRecommendGood')
    },
    //  免费列表
    channelGoodsList(ids) {
      let data = {
        branchId: this.branchId,
        ids: ids
      }
      this.$api.grouppurchase.getRecommendGood(data).then((res) => {
         if (res.success) {
          this.freeList = res.data;
        }
      })
    },
    // 分享
    handleShare() {
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf("micromessenger") != -1;
      if (isWeixin) {
        this.$refs.share.handleOpen();
      } else if (window.navigator.userAgent.includes("DingTalk")) {
        this.$refs.share.handleOpen();
      } else {
        this.$toast('请用浏览器自带的分享功能进行分享');
      }
      // 埋点活动页分享
      this.$sensors.track('mkt_page_share',{
        mkt_source: 'web',
      })
    },
    handleNavBack() {
      let endTime = new Date();
      // 埋点活动页浏览
      this.$sensors.track('mkt_page_show',{
        mkt_page_title: '818嗨课节',
        mkt_view_duration: (endTime - this.viewStart) / 1000
      })
      window.location.href= window.location.protocol+'//'+window.location.host;
    },
    openGoodsDetail(data) {
      this.$router.push({
        path: '/goodsDetail',
        query: {
          goodsId: data.goodsId || data.goodId,
          goodsKind: 2,
          isH5: 1,
          visit_referrer: '818嗨课节',
          position_number: data.index
        }
      })
    },
    onRefresh() {
      this.loading = true;
      this.findActivityTime();
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '../asset/css/activity.styl'
</style>
